import 'semantic-ui-less/definitions/modules/dropdown.less';import _default from './Dropdown';
export { _default as default };